import { Product } from "../Models/Product";
import { getApi } from "./Api";

export const getAllCardsInventary = async () => {
    try{
        return await getApi<{products:Product[]}>('frikistore-product/get-frikistore-products')
    }
    catch(error){
        throw error;
    }
}

export const getAllCardsInventarySoon = async () => {
    try{
        return await getApi<{products:Product[]}>('frikistore-product/get-frikistore-products-soon')
    }
    catch(error){
        throw error;
    }
}